import { jsx } from "react/jsx-runtime";
import { memo } from "react";
import { Button as Button$1 } from "@perxis-auto/ui-kit/lib/components/Button";
import { Skeleton } from "@perxis-auto/ui-kit/lib/components/Skeleton";
const Button = memo(function Button2({
  children,
  type = "primary",
  htmlType = "button",
  iconGapSize = "large",
  isLoading = false,
  ...props
}) {
  if (isLoading) {
    return /* @__PURE__ */ jsx(Skeleton.Button, { active: true, block: true, size: "large" });
  }
  return /* @__PURE__ */ jsx(Button$1, { type, htmlType, iconGapSize, ...props, children });
});
export {
  Button
};
